import { LoadState } from "../../constants/enums";
import {
  IUserCommission,
  IUserContinuingEducation,
  IUserLicense,
  IUserProfile,
  IUserSecuirtyGroup,
  IUsersState,
} from "./userProfile.types";

export const initialUser: IUserProfile = {
  user_fact_id: 0,
  username: "",
  user_code: "",
  job_title: "",
  first_name: null,
  last_name: null,
  user_type: null,
  mobile: null,
  home_phone: null,
  linkedin_profile: null,
  hire_date: null,
  last_day_at_work: null,
  branch: null,
  phone_ext: null,
  reports_to: null,
  department: null,
  fax: null,
  assigned_phone_number: null,
  date_of_birth: null,
  sin: null,
  broker: null,
  mother_maiden_name: null,
  photo: null,
  signature: null,
  street_address: null,
  unit_or_suite: null,
  city: null,
  province_or_state: null,
  postal_code: null,
  non_active_firm: null,
  non_active_firm_registered_with_ribo: null,
  non_active_firm_name: null,
  business_number: null,
  bank_name: null,
  bank: null,
  transit: null,
  account: null,
  languages_known: null,
  documents: null,
  csr: null,
  marketer: null,
  producer_one: null,
  producer_two: null,
  producer_three: null,
  branch_code: null,
  bonus_liability_code: null,
  bonus_expense_code: null,
  commission_liability_code: null,
  commission_expense_code: null,
  email: "",
  personal_email: null,
  country: null,
  shared_email: [],
  location_city: null,
  status: "ACTIVE",
  config_json: "",
  created_by_id: null,
  defaults_role: null,
  insert_ts: null,
  manager_id: null,
  role_id: null,
  user_profile_id: 0,
  producer_one_code: "",
  producer_three_code: "",
  producer_two_code: "",
  marketer_code: "",
  csr_code: "",
  full_name: null,
  report_email: null,
  notification_email: null,
  employment_status: null,
  employee_number: null,
  application_number: null,
};

export const initialSecurityGroup: IUserSecuirtyGroup = {
  user_fact_id: null,
  access_users_group: [
    {
      user_fact_id: null,
      user_name: ""
    }
  ],
  ends_on: null,
  status: "ACTIVE",
};
export const initialCommision: IUserCommission = {
  user_fact_id: 0,
  user_code: null,
  incremental_number: 0,
  policy_type: "All",
  policy_transaction_type: "All",
  producer_one_percentage: 0,
  producer_two_percentage: 0,
  producer_three_percentage: 0,
  branch_percentage: 0,
  house_percentage: 0,
  bonus_percentage: 0,
  status: "ACTIVE",
};

export const initialContinuingEducation: IUserContinuingEducation = {
  user_fact_id: 0,
  incremental_number: 0,
  full_name: null,
  user_code: null,
  email: null,
  course_name: null,
  course_category: null,
  provider_name: null,
  credit_hours: 0,
  completion_date: null,
  cycle_start_date: null,
  cycle_end_date: null,
  credit_hours_carried_forward: 0,
  course_category_carried_forward: null,
  file_upload: null,
  status: "ACTIVE",
};

export const initialUserLicense: IUserLicense = {
  user_fact_id: 0,
  incremental_number: 0,
  full_name: null,
  user_code: null,
  email: null,
  license_type: null,
  license_class: null,
  license_number: null,
  issuing_province: null,
  issuing_authority: null,
  issue_date: null,
  expiry_date: null,
  file_upload: null,
  is_resident: false,
  status: "ACTIVE",
};

export const initialUserProfileState: IUsersState = {
  users: {
    data: [],
    totalNumberOfRecords: 0,
    loading: LoadState.NotLoaded,
    user: initialUser,
    userLoading: LoadState.NotLoaded,
    error: null,
  },
  documents: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  userProfile: initialUser,
  userProfileLoading: LoadState.NotLoaded,
  userSecurityGroup: {
    data: initialSecurityGroup,
    loading: LoadState.NotLoaded,
  },
  commission: {
    list: [],
    data: initialCommision,
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  continuingEducation: {
    list: [],
    data: initialContinuingEducation,
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  userLicense: {
    list: [],
    data: initialUserLicense,
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
};



// {
//   first_name: null,
//   last_name: null,
//   user_type: null,
//   mobile: null,
//   home_phone: null,
//   linkedin_profile: null,
//   date_of_birth: null,
//   sin: null,
//   mother_maiden_name: null,
//   photo: null,
//   signature: null,
//   street_address: null,
//   unit_or_suite: null,
//   city: null,
//   province_or_state: null,
//   postal_code: null,
//   country: null,
//   non_active_firm: null,
//   non_active_firm_registered_with_ribo: null,
//   non_active_firm_name: null,
//   business_number: null,
//   bank_name: null,
//   bank: null,
//   bank_number: null,
//   transit: null,
//   account: null,
//   languages_known: null,
//   documents: null,
//   personal_email: null
// },
